import { ITEM } from '../../../../utils/ServiceUtils';
import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface ProjectItemCalculation {
    id?: string;
    projectId?: string;
    probability?: number;
    finalDate?: Date;
    amountWithVat?: number;
    amountWithoutVat?: number;
    currency?: string;
    amountWithoutVatBccy?: number;
    totalPurchase?: number;
    modified?: Date;
    catalogPrice?: number;
    catalogPriceBccy?: number;
    purchasePriceBccy?: number;
}

export interface IUpdateProjectItemCalculationRequest extends IBaseRequest {
    id: string;
    ITEM?: ProjectItemCalculation[];
}

export class UpdateProjectItemCalculationRequest extends BaseRequest implements IUpdateProjectItemCalculationRequest {
    public id: string;
    public ITEM?: ProjectItemCalculation[];
    constructor(server: string, session: string, id: string, ITEM?: ProjectItemCalculation[]) {
        super(server, session);
        this.id = id;
        this.ITEM = ITEM || [];
    }

    toProjectItemCalculationXML(projectItemCalculation: ProjectItemCalculation): string {
        var parameters: string = '';
        parameters += this.makeNode(projectItemCalculation.id, 'id');
        parameters += this.makeNode(projectItemCalculation.projectId, 'projectId');
        parameters += this.makeNode(projectItemCalculation.probability, 'probability');
        parameters += this.makeNodeDate(projectItemCalculation.finalDate, 'finalDate');
        parameters += this.makeNode(projectItemCalculation.amountWithVat, 'amountWithVat');
        parameters += this.makeNode(projectItemCalculation.amountWithoutVat, 'amountWithoutVat');
        parameters += this.makeNode(projectItemCalculation.currency, 'currency');
        parameters += this.makeNode(projectItemCalculation.amountWithoutVatBccy, 'amountWithoutVatBccy');
        parameters += this.makeNode(projectItemCalculation.totalPurchase, 'totalPurchase');
        parameters += this.makeNodeDate(projectItemCalculation.modified, 'modified');
        parameters += this.makeNode(projectItemCalculation.catalogPrice, 'catalogPrice');
        parameters += this.makeNode(projectItemCalculation.catalogPriceBccy, 'catalogPriceBccy');
        return `<ITEM>${parameters}</ITEM>`;
    }
    public toXml(): string {
        var parameters: string = super.toXml();
        parameters += this.makeNode(this.id, 'id');
        if (this.ITEM) {
            this.ITEM.forEach((item) => {
                parameters += this.toProjectItemCalculationXML(item);
            });
        }
        return super.wrapperXml(ITEM.updateProjectItemCalculation, parameters);
    }
}
